import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'curbnturf-hide-modal',
  templateUrl: './hide-modal.component.html',
  styleUrls: ['./hide-modal.component.scss'],
  standalone: true,
  imports: [IonicModule],
})
export class HideModalComponent {
  @Input() name: string;
  @Input() confirmFunction: () => void;
  @Input() declineFunction: () => void;
}
